var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"membersOnly"},[_c('PageHeader',{staticClass:"pghead"}),_c('PageContent',{staticClass:"pgcont"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }